<template>
<DemoVideo
  title="Python SDK Demo"
  :demoVideo="videoFile"
  :navKeys="['demos', 'python_demo']"
  :key="viewKey"
/>
</template>

<script>
import whoosh_python from '../assets/whoosh_python.mp4'

import DemoVideo from '@/components/DemoVideo.vue'

export default {
  data () {
    return {
      videoFile: whoosh_python,
      viewKey: 1
    }
  },
  components: { DemoVideo },
  beforeRouteUpdate () {
    this.viewKey += 1
  }
}
</script>
